import styled from 'styled-components';
import { StyledMenuButtonContentHeaderProps } from './types';
import { baseContainer } from '@redsift/design-system';

/**
 * Component style.
 */
export const StyledMenuButtonContentHeader = styled.div<StyledMenuButtonContentHeaderProps>`
  ${baseContainer}
`;
